<template>
  <div id="index_banner" v-if="banner.length !== 0">
    <index-nav :locale="locale"></index-nav>
    <swiper :options="swiperOption" ref="indexBanner">
      <!-- slides -->
      <swiper-slide v-for="item in banner" :key="item.image">
        <video v-if="item.type == 2" autoplay loop width="100%" height="9rem">
          <source :src="item.image" type="video/mp4" />
        </video>
        <a v-else :href="item.url" :alt="item.keyword" :data-id="item.bannerId">
          <img :src="item.image" alt="item.keyword" />
        </a>
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev" :style="prevImg"></div>
      <div class="swiper-button-next" slot="button-next" :style="nextImg"></div>
    </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import IndexNav from "./IndexNav";
const prevImgSrc = require("@/assets/images/icon_prev.png");
const nextImgSrc = require("@/assets/images/icon_next.png");
export default {
  components: {
    IndexNav,
    swiper,
    swiperSlide
  },
  methods: {},
  watch: {
    locale(a, b) {
      console.log("locale变化（indexbanner-indexproduct）", a, b);
    }
  },
  props: {
    locale: {
      type: String,
      default: "zh-cn"
    },
    banner: {
      type: Array,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      prevImg: {
        background: "url(" + prevImgSrc + ")",
        "background-size": "100% 100%"
      },
      nextImg: {
        background: "url(" + nextImgSrc + ")",
        "background-size": "100% 100%"
      },
      swiperOption: {
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
          bulletClass: "span-bullet",
          bulletActiveClass: "span-bullet-active",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoPlay: true,
        loop: true,
        simulateTouch: false,
        autoHeight: true,
        preloadImages: false,
        spaceBetween: 0
      }
    };
  },
  created() {
    // console.log(this.banner)
  },
  computed: {
    swiper() {
      return this.$refs.indexBanner.swiper;
    }
  }
};
</script>

<style scoped lang="scss">
#index_banner {
  width: 100%;
  .swiper-container {
    margin-top: 140px;
    .swiper-slide {
      display: flex;
      justify-content: center;
      width: 100%;
      img {
        width: 100%;
        object-fit: cover;
      }
    }
    .swiper-pagination {
      display: flex;
      flex-direction: row;
      justify-content: center;
      bottom: 50px;
    }
  }
}
video {
  width: 100%;
  height: 9rem;
}
@media screen and (max-width: 750px) {
  #index_banner {
    height: auto;
    .swiper-scrollbar {
      display: none;
    }
    margin-top: 60px;
    width: 100%;
    height: 200px;
    .swiper-container {
      width: 100%;
      height: 200px;
      position: relative;
      margin-top: 0;
      .swiper-wrapper {
        width: 100%;
        height: 200px;
        .swiper-slide {
          width: 100%;
          height: 200px;
          img {
            width: 100%;
            height: 200px;
            object-fit: cover;
          }
        }
      }
      .swiper-pagination {
        bottom: 15px;
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 1.2rem;
    height: 2rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>
<style lang="scss">
.span-bullet {
  display: block;
  width: 35px;
  height: 4px;
  margin: 0 4px;
  background: #565656;
  outline: none;
  cursor: pointer;
  &.span-bullet-active {
    background: #fff;
  }
}
.swiper-button-prev,
.swiper-button-next {
  width: 50px;
  height: 100px;
  margin: 0;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/Index/IndexBanner.vue